import React from 'react'

import { Card, CardBody } from '../../components/Card'

export const ExportWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Card>
      <CardBody>
          {children}
      </CardBody>
    </Card>
  )
}
